import React, { useState } from 'react';
import Icon from '@/components/icon/Icon';
import { IconsDictionary, IIcon } from '@/components/icon/Icon.types';
import FocusLock from 'react-focus-lock';
import DropdownStyled from './Dropdown.styled';
import useEventListener from '@/hooks/useEvenListener';
import { useKeyboardNavigation } from './Dropdown.utils';
import { useToolbarPosition } from '@/hooks/useToolbarPosition';

interface DropdownProps {
  id: string;
  defaultValue: string;
  onClose: () => void;
  onDropdownSelect?: (v: string) => void;
  options: {
    id: string;
    icon?: IIcon;
    label: string;
  }[];
}

const Dropdown = ({
  id,
  defaultValue,
  onClose,
  onDropdownSelect,
  options,
}: DropdownProps) => {
  const position = useToolbarPosition();
  const [selected, setSelected] = useState(defaultValue);

  const doHandleClick = (evtValue: string) => {
    setSelected(evtValue);
    if (onDropdownSelect) onDropdownSelect(evtValue);
  };

  const { onArrowDown, onArrowUp } = useKeyboardNavigation(
    '[data-dropdownid="dropdown-item"]'
  );

  useEventListener('keydown', evt => {
    if (evt.key === 'ArrowDown') onArrowDown(evt);
    if (evt.key === 'ArrowUp') onArrowUp(evt);
    if (
      evt.key === 'Escape' ||
      (position.includes('Right') && evt.key === 'ArrowRight') ||
      (position.includes('Left') && evt.key === 'ArrowLeft')
    )
      onClose();
  });

  return (
    <FocusLock>
      <DropdownStyled id="dropdown">
        <ul id={id} className="dropdown__list">
          {options.map(option => {
            return (
              <li key={option.id}>
                <button
                  className="dropdown__btn"
                  type="button"
                  data-dropdownid="dropdown-item"
                  data-dropdownactive={option.id === selected}
                  id={`dropdown-btn-${option.id}`}
                  onClick={() => doHandleClick(option.id)}
                >
                  {option.icon ? (
                    <Icon
                      icon={option.icon}
                      height={24}
                      width={24}
                      color="#00304d"
                    />
                  ) : (
                    <Icon
                      icon={IconsDictionary.Check}
                      color={selected === option.id ? '#00304d' : 'transparent'}
                      height={24}
                      width={24}
                    />
                  )}
                  {option.label}
                </button>
              </li>
            );
          })}
        </ul>
      </DropdownStyled>
    </FocusLock>
  );
};

export default Dropdown;
